<template>
  <div>
    <vx-card>
      <div class="flex items-center gap-3 font-medium">
        <p style="width: 114px">연도</p>
        <vs-select autocomplete v-model="selectYear" @change="changeYear">
          <vs-select-item v-for="year in years" :key="year" :value="year" :text="year" />
        </vs-select>
        <p>년</p>
      </div>
    </vx-card>
    <div class="flex items-center justify-end my-4">
      <vs-button type="border" color="secondary" @click="excelDownWithHtml('safety_staff_management_daily')">Excel 다운로드</vs-button>
    </div>
    <!-- 작업환경측정 결과(총괄) -->
    <div>
      <h5 class="mt-6 mb-4"><i class="dot"></i> 작업환경측정 결과(총괄)</h5>
      <table id="safety_staff_management_daily">
        <colgroup>
          <col width="80" />
          <col />
          <col style="background: #fafafa" />
        </colgroup>
        <thead>
          <tr>
            <th rowspan="3" class="th-gray">연번</th>
            <th rowspan="3" class="th-gray">사업장명</th>
            <th rowspan="3" class="th-gray">측정 회수</th>
            <th colspan="2">측정결과</th>
          </tr>
          <tr>
            <th>적합</th>
            <th>부적합</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(_data, _data_i) in tableData" :key="_data_i">
            <td>{{ _data_i + 1 }}</td>
            <td>{{ _data.si }}</td>
            <td>{{ _data.total }}</td>
            <td>{{ _data.main.adequate }}</td>
            <td>{{ _data.main.inadequate }}</td>
          </tr>

          <tr style="background: #f5f5ff">
            <td style="background: #fafafa">계</td>
            <td style="background: #fafafa"></td>
            <td style="background: #fafafa">{{ sumTableData.total }}</td>
            <td>{{ sumTableData.main.adequate }}</td>
            <td>{{ sumTableData.main.inadequate }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import HttpRequest from "@/util/HttpRequest";
import XLSX from "xlsx";

export default {
  name: 'Viewer659',
  data() {
    return {
      selectYear: new Date().getFullYear(),
      si: ["목포", "여수", "순천", "나주", "광양", "담양", "곡성", "구례", "고흥", "보성", "화순", "장흥", "강진", "해남", "영암", "무안", "함평", "영광", "장성", "완도", "진도", "신안"],
      tableData: [],
      sumTableData: {
        total: 0,
        preliminary: {
          total: 0,
          adequate: 0,
          inadequate: 0,
        },
        main: {
          total: 0,
          adequate: 0,
          inadequate: 0,
          none: 0,
        },
        noise: {
          total: 0,
          adequate: 0,
          remeasurement: 0,
        },
      },
    };
  },
  computed: {
    projectId() {
      return Number(this.$route.params.proj_id);
    },
    // 1970년부터 현제 년도까지
    years() {
      const currentYear = new Date().getFullYear();
      const years = [];
      for (let i = 1970; i <= currentYear; i++) {
        years.push(i);
      }
      years.reverse();
      return years;
    },
  },
  created() {
    this.getSummaryData();
  },
  methods: {
    changeYear() {
      this.tableData = [];
      this.getSummaryData();
    },
    getSummaryData() {
      const projectId = this.projectId;
      const targetYear = this.selectYear;

      HttpRequest.get(`/api/v1/summary/post/659`, { params: { projectId, targetYear } }).then((response) => {
        this.sumTableData = JSON.parse(JSON.stringify(response.sum.count));
        delete response.sum;

        for (const key in response) {
          this.tableData.push({ si: key, ...response[key].count });
        }

        console.log(this.tableData);
      });
    },
    excelDownWithHtml(tableName) {
      const wb = XLSX.utils.table_to_book(document.getElementById(tableName), { sheet: "작업환경측정 결과(총괄)", raw: true });
      XLSX.writeFile(wb, "작업환경측정 결과(총괄).xlsx");
    },
  },
};
</script>

<style lang="scss" scoped>
table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;

  background: white;

  th,
  td {
    border: 1px solid #cdcdcd;
  }

  th {
    font-size: 14px;
    font-weight: 500;
    line-height: 17px;
    text-align: center;
    background: #f5f5ff;
    padding: 11px 0;
    &.th-gray {
      background: #fafafa;
    }
  }

  td {
    font-size: 14px;
    font-weight: 400;
    line-height: 17px;
    text-align: center;
    padding: 11px 0;

    &:nth-child(3n) {
      font-weight: 500;
    }
  }
}
</style>
